<template>
  <div class="login-pos">
    <img class="login-pos__logo" src="@/assets/images/header/logo.png"/>
    <div class="login-pos__input-password">
      <b-form-input
        type="number"
        v-model="phone"
        placeholder="Enter Cellphone Number"
        class="text-center"
        autofocus="autofocus"
      />
    </div>
    <div class="login-pos__button-login">
      <b-button @click="handleLogin">Continue</b-button>
    </div>
  </div>
</template>
<script>
import authService from '@/services/auth.service';
export default {
  data() {
    return {
      phone: '',
      autofocus: true
    }
  },
  methods: {
    handleLogin() {
      authService.loginPos(this.phone).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Login successfully', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          });
          this.$store.commit('loginUser');
          this.$router.push('/ticket');
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
          this.$router.push('/ticket');
        }

      },
      () => this.$bvToast.toast('Login failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
      }));
    }
  }
}
</script>
